import "./NewClaimSummary.css"
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { BatchNumberObj, ReasonDetail } from "../utils/CreateClaimUtils";
import RenderSvg from "../../../components/renderSvg/RenderSvg";
import walletImageSrc from "../../../assets/image/png/wallet.png";
import { getLastNPathSegments, getTotalAmount, determineClaimTypes, ClaimDetail} from "../utils/utils";
import { getLast12Months } from "../../../utils/calenderUtils";
import { formatDecimal } from "../../../components/dms_common/DmsUtils";
import dayjs from "dayjs";
import ApprovalModal from "../modals/ApprovalModal";
import { useNavigate } from "react-router-dom";
import {
  setDisableEditing,
  setSelectedRowToEdit,
  setSelectedClaimSubType,
  setSaleReturnRows,
  setSaleReturnsCheckedClaimIds,
  setReturnProductsArray,
  setEditedBatches,
  setSecondarySchemesRows,
  setSecondarySchemesCheckedClaimIds,
  setMonth,
  setSearchText,
  setNonEligible
} from "../../../stateManagement/actions/claims";
import { Tooltip } from "@mui/material";
import {fetchSalesReturnData} from "../../SalesReturn/SalesReturnService";
import { navigateToSalesReturnDetails } from "../../SalesReturn/SalesReturnUtils";
import RenderTooltipContent from "../../../components/dms_common/RenderTooltipContent";
import { Loader } from "../../../components/loader/Loader";
import FormHeader from "../../../components/dms_common/FormHeader";
import { openPopup } from "../../../stateManagement/actions/popupActions";
interface ReturnOrderNo {
  batchIds: BatchNumberObj[];
  loginId?: string;
  creditGiven?: number;
}

const NewClaimSummary: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [approvalModalOpen, setApprovalModalOpen] = useState<boolean>(false);
  const [approvalModalState, setApprovalModalState] = useState<number>(1); // there are 2 states, 1 and 2
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const { caseUnitLabel, otherUnitLabel, packUnitLabel, currency, claimTypes, claimSubTypes, batchIdConfiguration, enableFocPurchaseReturnClaims } = ConfigDictionary;
  const { claimSummmaryRows, month, initialSaleReturnsRows, searchText, initialSecondarySchemesRows} = useSelector((state: any) => state.claims);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const path = getLastNPathSegments(window.location.href, 2);
  const secondLastSegment=path[1];
  const { claimType, subClaimType } = determineClaimTypes(secondLastSegment, claimTypes, claimSubTypes);

  useEffect(() => {
    if (!localStorage.getItem("localStorageClaimSummmaryRows"))
      localStorage.setItem(
        "localStorageClaimSummmaryRows",
        JSON.stringify(claimSummmaryRows)
      );
    return () =>{ localStorage.removeItem("localStorageClaimSummmaryRows");
    }
  }, []);

  const storedItem = localStorage.getItem("localStorageClaimSummmaryRows");
  let parsedItem = null;
  if (storedItem) {
    parsedItem = JSON.parse(storedItem);
  }

  const handleClickViewSaleReturnClaim = (rowData: any) => {
    dispatch(setSelectedRowToEdit(rowData));
    dispatch(setDisableEditing!(true));
    navigate("/dashboard/claims/create/saleReturns/editQuantity");
  };

 
  const RenderRightBottom = ({
    totalCreditGiven = 0,
    totalClaimAmount = 0,
  }) => {
    switch (secondLastSegment) {
      case "saleReturns":
        return (
          <div className="right-bottom-child">
            <LabelValue label="Total Credit Given" value={totalCreditGiven} />
          </div>
        );
      default:
        return (
          <div style={{ display: "flex", gap: "22px" }}>
            <LabelValue label="Total Amount" value={totalClaimAmount} />
          </div>
        );
    }
  };

  const LabelValue = ({ label = "", value = 0 }) => (
    <div>
      <p className="rbc-label">{label}</p>
      <p className="rbc-value">
      {label === "Total Credit Given" ? value : `${currency} ${formatDecimal(value)}` }
      </p>
    </div>
  );  

  const RenderRightTop = ({ cases = 0, pieces = 0, others = 0, foc=0, otherUnitName = otherUnitLabel }) => {
    switch (secondLastSegment) {
      case "saleReturns":
      case "purchaseReturns":
        return (
          <div className="right-top">
            {caseUnitLabel && (
              <div className="unit-qty-container">
                <div className="uqc-row">
                  <p className="uqc-label">Unit</p>
                  <p className="uqc-label-r">Qty</p>
                </div>
                <div className="uqc-row">
                  <p className="uqc-value">{caseUnitLabel}</p>
                  <p className="uqc-value-r">{cases}</p>
                </div>
              </div>
            )}
            {otherUnitName && (
              <div className="unit-qty-container">
                <div className="uqc-row">
                  <p className="uqc-label">Unit</p>
                  <p className="uqc-label-r">Qty</p>
                </div>
                <div className="uqc-row">
                  <p className="uqc-value">{otherUnitName}</p>
                  <p className="uqc-value-r">{others}</p>
                </div>
              </div>
            )}
            {packUnitLabel && (
              <div className="unit-qty-container">
                <div className="uqc-row">
                  <p className="uqc-label">Unit</p>
                  <p className="uqc-label-r">Qty</p>
                </div>
                <div className="uqc-row">
                  <p className="uqc-value">{packUnitLabel}</p>
                  <p className="uqc-value-r">{pieces}</p>
                </div>
              </div>
            )}
          </div>
        );
        case "secondarySchemes":
        return (
          <div className="purchase-returns-styles">
            <div className="right-top">
              {caseUnitLabel && (
                <div className="unit-qty-container">
                  <div className="uqc-row">
                    <p className="uqc-label">Unit</p>
                    <p className="uqc-label-r">Qty</p>
                  </div>
                  <div className="uqc-row">
                    <p className="uqc-value">{caseUnitLabel}</p>
                    <p className="uqc-value-r">{cases}</p>
                  </div>
                </div>
              )}
              {otherUnitName && (
                <div className="unit-qty-container">
                  <div className="uqc-row">
                    <p className="uqc-label">Unit</p>
                    <p className="uqc-label-r">Qty</p>
                  </div>
                  <div className="uqc-row">
                    <p className="uqc-value">{otherUnitName}</p>
                    <p className="uqc-value-r">{others}</p>
                  </div>
                </div>
              )}
              {packUnitLabel && (
                <div className="unit-qty-container">
                  <div className="uqc-row">
                    <p className="uqc-label">Unit</p>
                    <p className="uqc-label-r">Qty</p>
                  </div>
                  <div className="uqc-row">
                    <p className="uqc-value">{packUnitLabel}</p>
                    <p className="uqc-value-r">{pieces}</p>
                  </div>
                </div>
              )}
            </div>
            <div className="unit-qty-container" style={{ width: "18%" }}>
              <div className="uqc-row" style={{ justifyContent: "end" }}>
                <p className="uqc-label">FOC</p>
              </div>
              <div className="uqc-row" style={{ justifyContent: "end" }}>
                <p className="uqc-value">{foc}</p>
              </div>
            </div>
          </div>
        );
        case "totalOrderValue":
        return (
          <div className="purchase-returns-styles">
            <div className="right-top">
              {caseUnitLabel && (
                <div className="unit-qty-container">
                  <div className="uqc-row">
                    <p className="uqc-label">Unit</p>
                    <p className="uqc-label-r">Qty</p>
                  </div>
                  <div className="uqc-row">
                    <p className="uqc-value">{caseUnitLabel}</p>
                    <p className="uqc-value-r">{cases}</p>
                  </div>
                </div>
              )}
              {otherUnitLabel && (
                <div className="unit-qty-container">
                  <div className="uqc-row">
                    <p className="uqc-label">Unit</p>
                    <p className="uqc-label-r">Qty</p>
                  </div>
                  <div className="uqc-row">
                    <p className="uqc-value">{otherUnitLabel}</p>
                    <p className="uqc-value-r">{others}</p>
                  </div>
                </div>
              )}
              {packUnitLabel && (
                <div className="unit-qty-container">
                  <div className="uqc-row">
                    <p className="uqc-label">Unit</p>
                    <p className="uqc-label-r">Qty</p>
                  </div>
                  <div className="uqc-row">
                    <p className="uqc-value">{packUnitLabel}</p>
                    <p className="uqc-value-r">{pieces}</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        ); 
      default:
        return (
          <div className="purchase-returns-styles">
            <div className="right-top" style={{ width: "66.66%", gap: "35px" }}>
              <div className="unit-qty-container" style={{ width: "33.33%" }}>
                <div className="uqc-row" style={{ gap: "25px" }}>
                  <p className="uqc-label" style={{ marginBottom: "10px" }}>
                    Unit
                  </p>
                  <p className="uqc-label-r" style={{ marginBottom: "10px" }}>
                    Qty
                  </p>
                </div>
                <div className="uqc-row" style={{ gap: "20px" }}>
                  <p className="uqc-value">Case</p>
                  <p className="uqc-value-r">{cases}</p>
                </div>
              </div>
              <div className="unit-qty-container" style={{ width: "33.33%" }}>
                <div className="uqc-row" style={{ gap: "25px" }}>
                  <p className="uqc-label" style={{ marginBottom: "10px" }}>
                    Unit
                  </p>
                  <p className="uqc-label-r" style={{ marginBottom: "10px" }}>
                    Qty
                  </p>
                </div>
                <div className="uqc-row" style={{ gap: "20px" }}>
                  <p className="uqc-value">Piece</p>
                  <p className="uqc-value-r">{pieces}</p>
                </div>
              </div>
            </div>
          </div>
        );
    }
  };

  const rows = claimSummmaryRows?.length
  ? claimSummmaryRows
  : parsedItem
  ? parsedItem
  : []
  const loginId = JSON.parse(localStorage.authContext)?.user?.loginId;
  const supplierName = JSON.parse(localStorage.authContext)?.user?.name; 
  const totalCasesPieces = rows?.reduce(
    (acc: any, { cases = 0, pieces = 0, others = 0 } = {}) => {
      acc.cases += Number(cases);
      acc.pieces += Number(pieces);
      acc.others += Number(others); 
      return acc;
    },
    { cases: 0, pieces: 0, others: 0 } 
  );

const getTotalClaimAmount = (): number => {
  switch (secondLastSegment) {
    case "saleReturns":
      return getTotalAmount(rows,"totalClaimAmount");
    case "purchaseReturns":
      return getTotalAmount(rows,"totalClaimAmount");
    case "secondarySchemes":
      return getTotalAmount(rows,"finalAmount");
    case "totalOrderValue":
      return getTotalAmount(rows,"discount");
    default:
      return getTotalAmount(rows,"totalAmount");
  }
};

const getClaimTotalQuantity = (): string => {
  let totalCases = 0;
  let totalPieces = 0;
  let totalOthers = 0;

  rows.forEach((row: any) => {
      totalCases += row.cases || 0;
      totalPieces += row.pieces || 0;
      totalOthers += row.others || 0;
  });
  return `${totalCases}.${totalPieces}.${totalOthers}`;
};

const getClaimSummaryArr = (): Array<{ label: string; value: string | number }> => {
  const baseArr: { label: string; value: string | number }[] = [
    {
      label: "Claim Type",
      value: claimType,
    },
  ];

  if (secondLastSegment === "secondarySchemes") {
    baseArr.push(
        {
          label: "Scheme Type",
          value: subClaimType,
        },
      {
        label: "Selected Month",
        value: month,
      },
      {
        label: "No. of SKUs",
        value: rows.length,
      },
      {
        label: "Total Amount",
        value: getTotalAmount(rows, "totalAmount"),
      },
      {
        label: "Final Claim Amount",
        value: getTotalAmount(rows, "finalAmount"),
      }
    );
  } 
  else if(secondLastSegment === "totalOrderValue") {
    baseArr.push(
      {
        label: "Scheme Type",
        value: subClaimType,
      },
    {
      label: "Selected Month",
      value: month,
    },
    {
      label: "No. of Invoices",
      value: rows.length,
    },
    {
      label: "Total Amount",
      value: getTotalAmount(rows, "totalAmount"),
    },
    {
      label: "Final Claim Amount",
      value: getTotalAmount(rows, "discount"),
    }
  );
  }
  else if (secondLastSegment === "saleReturns" || secondLastSegment === "purchaseReturns") {
    baseArr.push(
      {
        label: "Type of Damage",
        value: subClaimType,
      }
    );

    if ((secondLastSegment === "saleReturns") && month) {
      baseArr.push({
        label: "Selected Month",
        value: month,
      });
    }

    baseArr.push({
      label: "Final Claim Amount",
      value: getTotalAmount(rows, "totalClaimAmount"),
    });
  }
  return baseArr;
};
const getClaimDetails = (): ClaimDetail[] => {
  const claimDetails: ClaimDetail[] = [];
  const selectedMonth = claimSummaryArr.find(item => item.label === "Selected Month")?.value;
  const convertMonthYearToDate = (monthYearString: string | undefined): string | undefined => {
    if (!monthYearString) return undefined;
    try {
      return dayjs(monthYearString).format("YYYY-MM-DD");
    } catch {
      return undefined;
    }
  };
  const displayStartDate = convertMonthYearToDate(selectedMonth as string);
  rows.forEach((row: any) => {
    if (secondLastSegment === "saleReturns") {
      const returnOrderNos: Record<string, ReturnOrderNo> = row.returnOrderNo || {};

      Object.entries(returnOrderNos).forEach(([referenceNumber, data]) => {
        if (typeof data !== 'object' || !data.batchIds) return;

        const batchIds: BatchNumberObj[] = data.batchIds;
        const creditGiven = data.creditGiven || 0;
        batchIds.forEach((batch: BatchNumberObj) => {
          batch.reasonDetails.forEach((reason: ReasonDetail) => {
            const claimedQty = `${reason.caseQty}.${reason.pieceQty}.${reason.otherQty}`;
            
            if(claimedQty === "0.0.0") return;

            const claimedAmount =
              reason.caseQty * (row.ptdCs || 0) +
              reason.pieceQty * (row.ptdPc || 0) +
              reason.otherQty * (row.ptdOther || 0);

            claimDetails.push({
              referenceNumber: referenceNumber || '',
              batchCode: batch.batchId || '',
              skuCode: row.skuCode || '',
              skuName: row.skuName || '',
              promotionId: row.promotionId || '',
              displayStartDate,
              claimedQty,
              approvedQty: 0,
              claimedAmount,
              approvedAmount: 0,
              remark: reason.reason || '',
              extendedAttributes: {ptdCs: row.ptdCs, ptdPc: row.ptdPc, ptdOther: row.ptdOther, batchCode: row.batchCode, creditGiven: creditGiven },
            });
          });
        });
      });
    } else if (secondLastSegment === "purchaseReturns") {
      const batchIds: BatchNumberObj[] = row.batchIds || [];

      batchIds.forEach((batch: BatchNumberObj) => {
        const reasonDetails = batch.reasonDetails || [];

        reasonDetails.forEach((reason: ReasonDetail) => {
          const claimedQtyCs = reason.caseQty || 0;
          const claimedQtyPc = reason.pieceQty || 0;
          const claimedQtyOther = reason.otherQty || 0;

          const claimedQty = `${claimedQtyCs}.${claimedQtyPc}.${claimedQtyOther}`;

          if (claimedQty === "0.0.0") return;

          let claimedAmount;
          let extendedAttributes;

          if (batchIdConfiguration) {
            claimedAmount =
              claimedQtyCs * (batch.ptdCs || 0) +
              claimedQtyPc * (batch.ptdPc || 0) +
              claimedQtyOther * (batch.ptdOther || 0);
            
            extendedAttributes = {
              ptdCs: batch.ptdCs || 0,
              ptdPc: batch.ptdPc || 0,
              ptdOther: batch.ptdOther || 0,
              ...(enableFocPurchaseReturnClaims && { stockType: batch.stockType || "normal" })
            };
          } else {
            claimedAmount =
              claimedQtyCs * (row.ptdCs || 0) +
              claimedQtyPc * (row.ptdPc || 0) +
              claimedQtyOther * (row.ptdOther || 0);
            
            extendedAttributes = {
              ptdCs: row.ptdCs || 0,
              ptdPc: row.ptdPc || 0,
              ptdOther: row.ptdOther || 0,
              ...(enableFocPurchaseReturnClaims && { stockType: batch.stockType || "normal" })
            };
          }

          claimDetails.push({
            referenceNumber: enableFocPurchaseReturnClaims ? batch.stockType : "",
            batchCode: batch.batchId || '',
            skuCode: row.skuCode || '',
            skuName: row.skuName || '',
            promotionId: "",
            claimedQty,
            approvedQty: 0,
            claimedAmount,
            approvedAmount: 0,
            remark: reason.reason || '',
            extendedAttributes
          });
        });
      });
    }
    else if (secondLastSegment === "secondarySchemes") {
      if (row.invoices && row.invoices.length > 0) {
        row.invoices.forEach((invoice: any) => {
          const claimedQty = `${invoice.cases}.${invoice.pieces}.${invoice.others}`;
          if (claimedQty === "0.0.0") return;
          claimDetails.push({
            referenceNumber: invoice.invoiceNumber || '',
            batchCode: batchIdConfiguration ? invoice.batchIds : row.skuCode,
            skuCode: row.skuCode || '',
            skuName: row.skuName || '',
            outletName: invoice.outletName || '',
            outletCode: invoice.outletCode || '',
            promotionId: "",
            displayStartDate,
            claimedQty,
            approvedQty: 0,
            claimedAmount: invoice.finalAmount || 0,
            approvedAmount: 0,
            remark: invoice.discountsAndPromotions[0] || '',
            extendedAttributes: {totalAmount: invoice.amount},
          });
        });
      }
    }
    else if (secondLastSegment === "totalOrderValue") {
      const claimedQty = `${row.cases}.${row.pieces}.${row.others}`;
      if (claimedQty === "0.0.0") return;
      claimDetails.push({
        referenceNumber: row.invoiceNo || '',
        batchCode: row.invoiceNo || '',
        skuCode: row.skuCode || '',
        skuName: row.skuName || '',
        promotionId: "",
        displayStartDate,
        claimedQty,
        approvedQty: 0,
        claimedAmount: row.discount || 0,
        approvedAmount: 0,
        remark: '',
        extendedAttributes: {invoiceDateTime: row.invoiceDateTime},
      });
    }
  });
  return claimDetails;
};
const claimSummaryArr = getClaimSummaryArr();
const claimDetails = getClaimDetails();
const claimSummaryObj = {
  claimType: (claimSummaryArr[0]?.value?.toString() || "").toUpperCase().replace(/\s+/g, ""),
  claimSubType: claimSummaryArr[1]?.value?.toString().toUpperCase().replace(/\s+/g, "").replace(".","") || "",
  claimTotalValue: (secondLastSegment === "saleReturns") ? claimSummaryArr[3]?.value || "" : (secondLastSegment === "purchaseReturns") ? claimSummaryArr[2]?.value || 0 : (secondLastSegment === "secondarySchemes" || secondLastSegment === "totalOrderValue") ? claimSummaryArr[5]?.value || "" : "", 
  claimApprovedValue: 0, 
  claimApprovalDate: "",
  supplier: loginId,
  supplierName,
  status: "REQUESTED",
  approverId: "",
  claimTotalQuantity: getClaimTotalQuantity()
}
  const postBody = { ...claimSummaryObj, claimDetails };

  const handleReturnOrderNoNavigate = async (item: string) => {
    try {
      setLoading(true);
      const data = await fetchSalesReturnData(undefined, undefined, item);
      if (data.length > 0) {
        await navigateToSalesReturnDetails("view", data[0], navigate, "Create New Claim");
      }
      else
      {
        openPopup("Error", "Failed to fetch sales return data");
      }
    } catch (error) {
      openPopup("Error", "Failed to fetch sales return data");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    return () => {
      const path = window.location.pathname;
      
      const isNavigatingToClaimsPage = path.includes('saleReturns') || 
                                      path.includes('purchaseReturns') || 
                                      path.includes('secondarySchemes');
      
      if (!isNavigatingToClaimsPage) {
        dispatch(setSaleReturnRows([])); 
        dispatch(setSaleReturnsCheckedClaimIds([]));
        dispatch(setReturnProductsArray([])); 
        dispatch(setEditedBatches([]));
        dispatch(setSearchText(""));
        dispatch(setSecondarySchemesRows(initialSecondarySchemesRows || []));
        dispatch(setSecondarySchemesCheckedClaimIds([]));
        const currentMonth = getLast12Months()[0];
        dispatch(setMonth(currentMonth));
        dispatch(setSelectedClaimSubType(""));
        dispatch(setNonEligible([]));
      }
    };
  }, []);

  return (
    <>
    {loading ? (
        <Loader />
      ) : (
    <div className="create-claim-root">
            <div className="claim-summary-heading heading">
              <FormHeader
                parentLabel={"Create New Claim "}
                label={"Claim Summary"}
                goBackToParent={() => navigate(-1)}
                />
            </div>
      <div className="claim-summary-container">
        <div className="summary-container">
          <div className="claim-summary-header">
            <p className="claim-summary-title">
              <div className="confirmed_order_icon">
                <RenderSvg name="orderConfirmedIcon" />
              </div>
              Claim Summary
            </p>
          </div>
          <div className="claim-summary-main">
            {getClaimSummaryArr()?.map((obj) => {
              const { label, value } = obj;
              return (
                <div className="label-value-container" key={label}>
                  <span className="claim-label">{label}</span>
                  <span
                    className={`claim-value ${
                      label === "Final Claim Amount" ? "largeAndBold" : ""
                    }`}
                  >
                    {label === "Final Claim Amount" || label === "Total Amount"
                      ? `${currency} ${typeof value === 'number' ? formatDecimal(value) : value}`
                      : value}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
        <div className="sku-details-container">
          <div className="sku-details-header">
            <p className="claim-summary-title">
              <div className="confirmed_order_icon">
                <RenderSvg name="orderConfirmedIcon" />
              </div>
              {!(secondLastSegment === "totalOrderValue") ? "SKU Details" : "Invoice Details"}
            </p>
            <button
              className="claim-summary-edit-button"
              onClick={() => navigate(-1)}
            >
              {secondLastSegment === "saleReturns" || secondLastSegment === "purchaseReturns" ? (
                <span className="edit-button-text-claim" style={{ color: "#1b7ea0" }}>
                  + Add More SKUs
                </span>
              ) : (
                <>
                  <div className="summary-edit-button">
                    <RenderSvg name={"viewAndEditIcon"} />
                  </div>
                  <span className="edit-button-text-claim">EDIT</span>
                </>
              )}
            </button>
          </div>
          <div className="sku-details-main">
            {(claimSummmaryRows?.length
              ? claimSummmaryRows
              : parsedItem
              ? parsedItem
              : []
            )?.map((claim: any, idx: any, arr: any) => {
              const {
                skuName,
                skuCode,
                returnOrderNo,
                cases,
                pieces,
                others,
                otherUnitName,
                totalCreditGiven,
                totalClaimAmount,
                finalAmount,
                discount,
                totalFoc,
                totalAmount,
                invoices,
                invoiceNo,
                invoiceDateTime
              } = claim;

              const invoiceNumbers = invoices?.map((inv: any) => inv.invoiceNumber) || [];
              const returnOrderKeys = returnOrderNo ? Object.keys(returnOrderNo) : [];
              return (
                <div
                  key={idx}
                  className="sku-detail-card"
                  style={
                    idx === arr.length - 1 && arr.length > 1
                      ? { borderBottomWidth: 0 }
                      : {}
                  }
                >
                  <div
                    className="detail-card-left"
                    style={{
                      justifyContent:
                        secondLastSegment === "saleReturns"
                          ? "center"
                          : "start",
                      marginTop:
                        secondLastSegment === "saleReturns" ? "-7px" : "20px",
                    }}
                  >
                    <p
                      className="sku-name"
                      title={secondLastSegment === "totalOrderValue" ? invoiceNo : skuName}
                    >
                      {secondLastSegment === "totalOrderValue" ? invoiceNo : skuName}
                    </p>
                    <p className="return-order-number-label">
                      {secondLastSegment === "saleReturns"
                        ? "Return order no."
                        : (secondLastSegment === "secondarySchemes")
                          ? "Invoice No."
                          : (secondLastSegment === "totalOrderValue")
                          ? "Invoice Date and Time"
                          : "SKU Code"}
                    </p>
                    <p className="return-order-number-value">
                    {secondLastSegment === "saleReturns" ? (
                        <div style={{ cursor: "pointer", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                          <Tooltip
                            title={<RenderTooltipContent items={returnOrderKeys} title="Return Order No" handleRedirect={handleReturnOrderNoNavigate} />}
                            placement="right"
                            arrow
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  backgroundColor: "#FFFFFF !important",
                                  color: "#000000 !important",
                                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1) !important",
                                  marginLeft: "-28px",
                                },
                              },
                              arrow: {
                                sx: {
                                  color: "#FFFFFF !important",
                                },
                              },
                            }}
                          >
                            <span>
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleReturnOrderNoNavigate(returnOrderKeys[0]);
                                }}
                              >
                                {returnOrderKeys[0]?.slice(0, 20)}…
                              </span>                              {returnOrderKeys?.length > 1 && (
                                <span style={{ color: "#2568E5", textDecoration: "underline" }}>
                                  +{returnOrderKeys?.length - 1}
                                </span>
                              )}
                            </span>
                          </Tooltip>
                        </div>
                      ) : (secondLastSegment === "secondarySchemes") ? (
            <div style={{ cursor: "pointer", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
            {invoiceNumbers?.[0] || ""}
            {invoiceNumbers?.length > 1 && (
            <Tooltip
              title={<RenderTooltipContent items={invoiceNumbers} title="Invoice No" />}
              placement="right"
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "#FFFFFF !important",
                    color: "#000000 !important",
                    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1) !important",
                    marginLeft: "-28px",
                  },
                },
                arrow: {
                  sx: {
                    color: "#FFFFFF !important",
                  },
                },
              }}
            >
                  <span style={{ color: "#2568E5", textDecoration: "underline" }}>
                    +{invoiceNumbers?.length - 1}
                  </span>
            </Tooltip>
            )}
            </div>
          ) : (secondLastSegment === "totalOrderValue") ? (<> {invoiceDateTime}</>)
          : (secondLastSegment === "purchaseReturns") ? (<span style={{ display: "inline-flex", gap: "2px" }}> {skuCode} {enableFocPurchaseReturnClaims && claim.stockType === "foc" && (
            <RenderSvg name="focIcon"/>
          )}</span>)  
          :(
            ""
          )}
          </p>
                    {secondLastSegment === "saleReturns" && (
                      <p
                        onClick={() => handleClickViewSaleReturnClaim(claim)}
                        className="view-details"
                      >
                        View Details
                      </p>
                    )}
                  </div>

                  <div className="detail-card-right">
                    <RenderRightTop cases={cases} pieces={pieces} others={others} foc={totalFoc} otherUnitName={otherUnitName}/>

                    <div className="right-bottom">
                      <RenderRightBottom
                        totalCreditGiven={totalCreditGiven}
                        totalClaimAmount={totalClaimAmount || totalAmount}
                      />
                      <div className="right-botton-child">
                        <p className="rbc-label">
                          {secondLastSegment === "saleReturns"
                            ? "Total Claim Amt"
                            : (secondLastSegment === "secondarySchemes" || secondLastSegment === "totalOrderValue")
                            ? "Discount Claim Amount"
                            : "" }
                            
                        </p>
                        <p className="rbc-value" style={{ textAlign: "right" }}>
                          {secondLastSegment === "saleReturns"
                            ? `${currency} ${formatDecimal(totalClaimAmount)}`
                            : secondLastSegment === "secondarySchemes"
                            ? `${currency} ${formatDecimal(finalAmount)}`
                            : secondLastSegment === "totalOrderValue"
                            ? `${currency} ${formatDecimal(discount)}`
                            : "" 
                          }
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <footer className="claim-summary-footer">
          <div className="claim-f-left">
            <div className="wallet-icon">
              <p className="wallet-qty">{claimSummmaryRows?.length}</p>
              <img style={{ width: "33px" }} src={walletImageSrc} alt="walletIcon"/>
            </div>
            <p className="total-quan-text">
              Total Quantity :
              <span className="total-quan-span">
                &nbsp;
                {caseUnitLabel && `${totalCasesPieces.cases} ${caseUnitLabel}, `}
                {otherUnitLabel && `${totalCasesPieces.others} ${otherUnitLabel}, `}
                {packUnitLabel && `${totalCasesPieces.pieces} ${packUnitLabel}`}
              </span>
            </p>
            <p className="total-quan-text">
              {(secondLastSegment === "secondarySchemes" || secondLastSegment === "totalOrderValue")
                ? "Discount Claim Amount : "
                : "Final Claim Amount : "}
              <span className="total-quan-span">
              &nbsp;{`${currency} ${formatDecimal(getTotalClaimAmount())}`}
              </span>
            </p>
          </div>
          <div className="claim-f-right">
            <button
              className="button-save-claim"
              onClick={() => setApprovalModalOpen(true)}
              disabled={!claimSummmaryRows?.length}
            >
              <span className="button-save-text-claim">Raise for Approval</span>
            </button>
          </div>
        </footer>

        <ApprovalModal
          approvalModalOpen={approvalModalOpen}
          setApprovalModalOpen={setApprovalModalOpen}
          approvalModalState={approvalModalState}
          setApprovalModalState={setApprovalModalState}
          postBody={postBody}
          claimType={claimSummaryArr[0]?.value.toString()}
          claimSubtype={claimSummaryArr[1]?.value?.toString()}
          />
      </div>
    </div>
      )}
    </>
  );
};

export default NewClaimSummary;
